import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _62b7ac6a = () => interopDefault(import('../pages/agreement.vue' /* webpackChunkName: "pages/agreement" */))
const _6e036c8a = () => interopDefault(import('../pages/audit.vue' /* webpackChunkName: "pages/audit" */))
const _1d455004 = () => interopDefault(import('../pages/audit/index.vue' /* webpackChunkName: "pages/audit/index" */))
const _400aedae = () => interopDefault(import('../pages/audit/company.vue' /* webpackChunkName: "pages/audit/company" */))
const _79c42fb6 = () => interopDefault(import('../pages/audit/failure.vue' /* webpackChunkName: "pages/audit/failure" */))
const _38d91859 = () => interopDefault(import('../pages/audit/person.vue' /* webpackChunkName: "pages/audit/person" */))
const _c13e8a48 = () => interopDefault(import('../pages/audit/review.vue' /* webpackChunkName: "pages/audit/review" */))
const _1f2db676 = () => interopDefault(import('../pages/audit/status.vue' /* webpackChunkName: "pages/audit/status" */))
const _04cf71a7 = () => interopDefault(import('../pages/audit/submitted.vue' /* webpackChunkName: "pages/audit/submitted" */))
const _9aa14ca2 = () => interopDefault(import('../pages/audit/success.vue' /* webpackChunkName: "pages/audit/success" */))
const _0d3db529 = () => interopDefault(import('../pages/column/index.vue' /* webpackChunkName: "pages/column/index" */))
const _08ee773e = () => interopDefault(import('../pages/contactUs.vue' /* webpackChunkName: "pages/contactUs" */))
const _3cc34ed7 = () => interopDefault(import('../pages/customerService.vue' /* webpackChunkName: "pages/customerService" */))
const _ef2a61ee = () => interopDefault(import('../pages/glhProtocal.vue' /* webpackChunkName: "pages/glhProtocal" */))
const _596b1bea = () => interopDefault(import('../pages/introduction.vue' /* webpackChunkName: "pages/introduction" */))
const _4c483d3f = () => interopDefault(import('../pages/live/index.vue' /* webpackChunkName: "pages/live/index" */))
const _2cd40e8f = () => interopDefault(import('../pages/market/index.vue' /* webpackChunkName: "pages/market/index" */))
const _c2efb126 = () => interopDefault(import('../pages/member/index.vue' /* webpackChunkName: "pages/member/index" */))
const _b9deeeca = () => interopDefault(import('../pages/memberService.vue' /* webpackChunkName: "pages/memberService" */))
const _541a9fa6 = () => interopDefault(import('../pages/myStock/index.vue' /* webpackChunkName: "pages/myStock/index" */))
const _fba9bb34 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _2efa3dcc = () => interopDefault(import('../pages/privacypolicy.vue' /* webpackChunkName: "pages/privacypolicy" */))
const _65ac8cc4 = () => interopDefault(import('../pages/recruit.vue' /* webpackChunkName: "pages/recruit" */))
const _73c9a5e1 = () => interopDefault(import('../pages/relief.vue' /* webpackChunkName: "pages/relief" */))
const _596c08fb = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _e07863e2 = () => interopDefault(import('../pages/subject/index.vue' /* webpackChunkName: "pages/subject/index" */))
const _52aa138e = () => interopDefault(import('../pages/column/columnist/index.vue' /* webpackChunkName: "pages/column/columnist/index" */))
const _f10e4136 = () => interopDefault(import('../pages/member/failure.vue' /* webpackChunkName: "pages/member/failure" */))
const _9fa77c3e = () => interopDefault(import('../pages/member/payment.vue' /* webpackChunkName: "pages/member/payment" */))
const _f74e1c60 = () => interopDefault(import('../pages/member/privilegeintro.vue' /* webpackChunkName: "pages/member/privilegeintro" */))
const _7f37ed44 = () => interopDefault(import('../pages/member/success.vue' /* webpackChunkName: "pages/member/success" */))
const _09de7dcc = () => interopDefault(import('../pages/my/comment.vue' /* webpackChunkName: "pages/my/comment" */))
const _2478b47f = () => interopDefault(import('../pages/my/favorite.vue' /* webpackChunkName: "pages/my/favorite" */))
const _d53e0bfe = () => interopDefault(import('../pages/my/follower.vue' /* webpackChunkName: "pages/my/follower" */))
const _32f35084 = () => interopDefault(import('../pages/my/following.vue' /* webpackChunkName: "pages/my/following" */))
const _7bb116ce = () => interopDefault(import('../pages/my/notification.vue' /* webpackChunkName: "pages/my/notification" */))
const _67da547c = () => interopDefault(import('../pages/my/publish.vue' /* webpackChunkName: "pages/my/publish" */))
const _d18c9538 = () => interopDefault(import('../pages/my/purchase.vue' /* webpackChunkName: "pages/my/purchase" */))
const _f5978586 = () => interopDefault(import('../pages/my/setting.vue' /* webpackChunkName: "pages/my/setting" */))
const _04896443 = () => interopDefault(import('../pages/my/stock.vue' /* webpackChunkName: "pages/my/stock" */))
const _66854e9a = () => interopDefault(import('../pages/column/page/_id.vue' /* webpackChunkName: "pages/column/page/_id" */))
const _0a30e5ef = () => interopDefault(import('../pages/column/user/_id.vue' /* webpackChunkName: "pages/column/user/_id" */))
const _5e75e94d = () => interopDefault(import('../pages/market/hotRange/_type.vue' /* webpackChunkName: "pages/market/hotRange/_type" */))
const _d19fc6b0 = () => interopDefault(import('../pages/market/marketRange/_type.vue' /* webpackChunkName: "pages/market/marketRange/_type" */))
const _734ef354 = () => interopDefault(import('../pages/news/page/_id.vue' /* webpackChunkName: "pages/news/page/_id" */))
const _0ef28367 = () => interopDefault(import('../pages/live/_id.vue' /* webpackChunkName: "pages/live/_id" */))
const _6be268b7 = () => interopDefault(import('../pages/market/_id.vue' /* webpackChunkName: "pages/market/_id" */))
const _a8816998 = () => interopDefault(import('../pages/member/_type.vue' /* webpackChunkName: "pages/member/_type" */))
const _3328ca92 = () => interopDefault(import('../pages/member/_type/index.vue' /* webpackChunkName: "pages/member/_type/index" */))
const _c3011cc0 = () => interopDefault(import('../pages/member/_type/article-index.vue' /* webpackChunkName: "pages/member/_type/article-index" */))
const _4a6af364 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _080de57b = () => interopDefault(import('../pages/p/_id.vue' /* webpackChunkName: "pages/p/_id" */))
const _b4841eb2 = () => interopDefault(import('../pages/rss-detail/_id.vue' /* webpackChunkName: "pages/rss-detail/_id" */))
const _22159bbe = () => interopDefault(import('../pages/stock/_id.vue' /* webpackChunkName: "pages/stock/_id" */))
const _1ebc0837 = () => interopDefault(import('../pages/subject/_id.vue' /* webpackChunkName: "pages/subject/_id" */))
const _b522e01a = () => interopDefault(import('../pages/tags/_type.vue' /* webpackChunkName: "pages/tags/_type" */))
const _73b96f46 = () => interopDefault(import('../pages/user/_id.vue' /* webpackChunkName: "pages/user/_id" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _70174796 = () => interopDefault(import('../pages/index/index.vue' /* webpackChunkName: "pages/index/index" */))
const _5741ee47 = () => interopDefault(import('../pages/index/tag/_type.vue' /* webpackChunkName: "pages/index/tag/_type" */))
const _182c8070 = () => interopDefault(import('../pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */))
const _c55a1a1a = () => interopDefault(import('../pages/_lang/index/index.vue' /* webpackChunkName: "pages/_lang/index/index" */))
const _cc4a13f6 = () => interopDefault(import('../pages/_lang/index/tag/_type.vue' /* webpackChunkName: "pages/_lang/index/tag/_type" */))
const _a0ae4ab0 = () => interopDefault(import('../pages/_lang/agreement.vue' /* webpackChunkName: "pages/_lang/agreement" */))
const _53cc46f9 = () => interopDefault(import('../pages/_lang/audit.vue' /* webpackChunkName: "pages/_lang/audit" */))
const _72882288 = () => interopDefault(import('../pages/_lang/audit/index.vue' /* webpackChunkName: "pages/_lang/audit/index" */))
const _4fe32f32 = () => interopDefault(import('../pages/_lang/audit/company.vue' /* webpackChunkName: "pages/_lang/audit/company" */))
const _71d80ef4 = () => interopDefault(import('../pages/_lang/audit/failure.vue' /* webpackChunkName: "pages/_lang/audit/failure" */))
const _0f4d595b = () => interopDefault(import('../pages/_lang/audit/person.vue' /* webpackChunkName: "pages/_lang/audit/person" */))
const _75d4fbde = () => interopDefault(import('../pages/_lang/audit/review.vue' /* webpackChunkName: "pages/_lang/audit/review" */))
const _14bc1110 = () => interopDefault(import('../pages/_lang/audit/status.vue' /* webpackChunkName: "pages/_lang/audit/status" */))
const _47687965 = () => interopDefault(import('../pages/_lang/audit/submitted.vue' /* webpackChunkName: "pages/_lang/audit/submitted" */))
const _aa798e26 = () => interopDefault(import('../pages/_lang/audit/success.vue' /* webpackChunkName: "pages/_lang/audit/success" */))
const _389c13aa = () => interopDefault(import('../pages/_lang/column/index.vue' /* webpackChunkName: "pages/_lang/column/index" */))
const _55dfa57c = () => interopDefault(import('../pages/_lang/contactUs.vue' /* webpackChunkName: "pages/_lang/contactUs" */))
const _7f5c5695 = () => interopDefault(import('../pages/_lang/customerService.vue' /* webpackChunkName: "pages/_lang/customerService" */))
const _5dc965c7 = () => interopDefault(import('../pages/_lang/glhProtocal.vue' /* webpackChunkName: "pages/_lang/glhProtocal" */))
const _2fdf5cec = () => interopDefault(import('../pages/_lang/introduction.vue' /* webpackChunkName: "pages/_lang/introduction" */))
const _c506527e = () => interopDefault(import('../pages/_lang/live/index.vue' /* webpackChunkName: "pages/_lang/live/index" */))
const _03484f91 = () => interopDefault(import('../pages/_lang/market/index.vue' /* webpackChunkName: "pages/_lang/market/index" */))
const _74fc686f = () => interopDefault(import('../pages/_lang/member/index.vue' /* webpackChunkName: "pages/_lang/member/index" */))
const _c9b7304e = () => interopDefault(import('../pages/_lang/memberService.vue' /* webpackChunkName: "pages/_lang/memberService" */))
const _63f2e12a = () => interopDefault(import('../pages/_lang/myStock/index.vue' /* webpackChunkName: "pages/_lang/myStock/index" */))
const _59408830 = () => interopDefault(import('../pages/_lang/news/index.vue' /* webpackChunkName: "pages/_lang/news/index" */))
const _3ed27f50 = () => interopDefault(import('../pages/_lang/privacypolicy.vue' /* webpackChunkName: "pages/_lang/privacypolicy" */))
const _47254148 = () => interopDefault(import('../pages/_lang/recruit.vue' /* webpackChunkName: "pages/_lang/recruit" */))
const _42bb5063 = () => interopDefault(import('../pages/_lang/relief.vue' /* webpackChunkName: "pages/_lang/relief" */))
const _2fe049fd = () => interopDefault(import('../pages/_lang/search/index.vue' /* webpackChunkName: "pages/_lang/search/index" */))
const _f050a566 = () => interopDefault(import('../pages/_lang/subject/index.vue' /* webpackChunkName: "pages/_lang/subject/index" */))
const _396b0be0 = () => interopDefault(import('../pages/_lang/column/columnist/index.vue' /* webpackChunkName: "pages/_lang/column/columnist/index" */))
const _2db5dcc4 = () => interopDefault(import('../pages/_lang/live/index.1.vue' /* webpackChunkName: "pages/_lang/live/index.1" */))
const _dc3e3032 = () => interopDefault(import('../pages/_lang/member/failure.vue' /* webpackChunkName: "pages/_lang/member/failure" */))
const _8ad76b3a = () => interopDefault(import('../pages/_lang/member/payment.vue' /* webpackChunkName: "pages/_lang/member/payment" */))
const _3eb0b30e = () => interopDefault(import('../pages/_lang/member/privilegeintro.vue' /* webpackChunkName: "pages/_lang/member/privilegeintro" */))
const _6a67dc40 = () => interopDefault(import('../pages/_lang/member/success.vue' /* webpackChunkName: "pages/_lang/member/success" */))
const _5b13174e = () => interopDefault(import('../pages/_lang/my/comment.vue' /* webpackChunkName: "pages/_lang/my/comment" */))
const _0c516986 = () => interopDefault(import('../pages/_lang/my/favorite.vue' /* webpackChunkName: "pages/_lang/my/favorite" */))
const _6abf90bf = () => interopDefault(import('../pages/_lang/my/follower.vue' /* webpackChunkName: "pages/_lang/my/follower" */))
const _860ace80 = () => interopDefault(import('../pages/_lang/my/following.vue' /* webpackChunkName: "pages/_lang/my/following" */))
const _836bc2e8 = () => interopDefault(import('../pages/_lang/my/notification.vue' /* webpackChunkName: "pages/_lang/my/notification" */))
const _8de22404 = () => interopDefault(import('../pages/_lang/my/publish.vue' /* webpackChunkName: "pages/_lang/my/publish" */))
const _6c984c22 = () => interopDefault(import('../pages/_lang/my/purchase.vue' /* webpackChunkName: "pages/_lang/my/purchase" */))
const _532e5282 = () => interopDefault(import('../pages/_lang/my/setting.vue' /* webpackChunkName: "pages/_lang/my/setting" */))
const _448b1376 = () => interopDefault(import('../pages/_lang/my/stock.vue' /* webpackChunkName: "pages/_lang/my/stock" */))
const _0f566071 = () => interopDefault(import('../pages/_lang/column/page/_id.vue' /* webpackChunkName: "pages/_lang/column/page/_id" */))
const _4cc9edad = () => interopDefault(import('../pages/_lang/column/user/_id.vue' /* webpackChunkName: "pages/_lang/column/user/_id" */))
const _18cdaa8b = () => interopDefault(import('../pages/_lang/market/hotRange/_type.vue' /* webpackChunkName: "pages/_lang/market/hotRange/_type" */))
const _fd5e2aac = () => interopDefault(import('../pages/_lang/market/marketRange/_type.vue' /* webpackChunkName: "pages/_lang/market/marketRange/_type" */))
const _832734d8 = () => interopDefault(import('../pages/_lang/news/page/_id.vue' /* webpackChunkName: "pages/_lang/news/page/_id" */))
const _2fb8d52e = () => interopDefault(import('../pages/_lang/live/_id.vue' /* webpackChunkName: "pages/_lang/live/_id" */))
const _85d1fb8e = () => interopDefault(import('../pages/_lang/market/_id.vue' /* webpackChunkName: "pages/_lang/market/_id" */))
const _fb98e794 = () => interopDefault(import('../pages/_lang/member/_type.vue' /* webpackChunkName: "pages/_lang/member/_type" */))
const _1690db8e = () => interopDefault(import('../pages/_lang/member/_type/index.vue' /* webpackChunkName: "pages/_lang/member/_type/index" */))
const _f8b671bc = () => interopDefault(import('../pages/_lang/member/_type/article-index.vue' /* webpackChunkName: "pages/_lang/member/_type/article-index" */))
const _9808cf60 = () => interopDefault(import('../pages/_lang/news/_id.vue' /* webpackChunkName: "pages/_lang/news/_id" */))
const _da483a8e = () => interopDefault(import('../pages/_lang/p/_id.vue' /* webpackChunkName: "pages/_lang/p/_id" */))
const _9fb40dae = () => interopDefault(import('../pages/_lang/rss-detail/_id.vue' /* webpackChunkName: "pages/_lang/rss-detail/_id" */))
const _3be6605f = () => interopDefault(import('../pages/_lang/stock/_id.vue' /* webpackChunkName: "pages/_lang/stock/_id" */))
const _17cac216 = () => interopDefault(import('../pages/_lang/subject/_id.vue' /* webpackChunkName: "pages/_lang/subject/_id" */))
const _12b9ad16 = () => interopDefault(import('../pages/_lang/tags/_type.vue' /* webpackChunkName: "pages/_lang/tags/_type" */))
const _4cea8148 = () => interopDefault(import('../pages/_lang/user/_id.vue' /* webpackChunkName: "pages/_lang/user/_id" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
      path: "/agreement",
      component: _62b7ac6a,
      name: "agreement"
    }, {
      path: "/audit",
      component: _6e036c8a,
      children: [{
        path: "",
        component: _1d455004,
        name: "audit"
      }, {
        path: "company",
        component: _400aedae,
        name: "audit-company"
      }, {
        path: "failure",
        component: _79c42fb6,
        name: "audit-failure"
      }, {
        path: "person",
        component: _38d91859,
        name: "audit-person"
      }, {
        path: "review",
        component: _c13e8a48,
        name: "audit-review"
      }, {
        path: "status",
        component: _1f2db676,
        name: "audit-status"
      }, {
        path: "submitted",
        component: _04cf71a7,
        name: "audit-submitted"
      }, {
        path: "success",
        component: _9aa14ca2,
        name: "audit-success"
      }]
    }, {
      path: "/column",
      component: _0d3db529,
      name: "column"
    }, {
      path: "/contactUs",
      component: _08ee773e,
      name: "contactUs"
    }, {
      path: "/customerService",
      component: _3cc34ed7,
      name: "customerService"
    }, {
      path: "/glhProtocal",
      component: _ef2a61ee,
      name: "glhProtocal"
    }, {
      path: "/introduction",
      component: _596b1bea,
      name: "introduction"
    }, {
      path: "/live",
      component: _4c483d3f,
      name: "live"
    }, {
      path: "/market",
      component: _2cd40e8f,
      name: "market"
    }, {
      path: "/member",
      component: _c2efb126,
      name: "member"
    }, {
      path: "/memberService",
      component: _b9deeeca,
      name: "memberService"
    }, {
      path: "/myStock",
      component: _541a9fa6,
      name: "myStock"
    }, {
      path: "/news",
      component: _fba9bb34,
      name: "news"
    }, {
      path: "/privacypolicy",
      component: _2efa3dcc,
      name: "privacypolicy"
    }, {
      path: "/recruit",
      component: _65ac8cc4,
      name: "recruit"
    }, {
      path: "/relief",
      component: _73c9a5e1,
      name: "relief"
    }, {
      path: "/search",
      component: _596c08fb,
      name: "search"
    }, {
      path: "/subject",
      component: _e07863e2,
      name: "subject"
    }, {
      path: "/column/columnist",
      component: _52aa138e,
      name: "column-columnist"
    }, {
      path: "/member/failure",
      component: _f10e4136,
      name: "member-failure"
    }, {
      path: "/member/payment",
      component: _9fa77c3e,
      name: "member-payment"
    }, {
      path: "/member/privilegeintro",
      component: _f74e1c60,
      name: "member-privilegeintro"
    }, {
      path: "/member/success",
      component: _7f37ed44,
      name: "member-success"
    }, {
      path: "/my/comment",
      component: _09de7dcc,
      name: "my-comment"
    }, {
      path: "/my/favorite",
      component: _2478b47f,
      name: "my-favorite"
    }, {
      path: "/my/follower",
      component: _d53e0bfe,
      name: "my-follower"
    }, {
      path: "/my/following",
      component: _32f35084,
      name: "my-following"
    }, {
      path: "/my/notification",
      component: _7bb116ce,
      name: "my-notification"
    }, {
      path: "/my/publish",
      component: _67da547c,
      name: "my-publish"
    }, {
      path: "/my/purchase",
      component: _d18c9538,
      name: "my-purchase"
    }, {
      path: "/my/setting",
      component: _f5978586,
      name: "my-setting"
    }, {
      path: "/my/stock",
      component: _04896443,
      name: "my-stock"
    }, {
      path: "/column/page/:id?",
      component: _66854e9a,
      name: "column-page-id"
    }, {
      path: "/column/user/:id?",
      component: _0a30e5ef,
      name: "column-user-id"
    }, {
      path: "/market/hotRange/:type?",
      component: _5e75e94d,
      name: "market-hotRange-type"
    }, {
      path: "/market/marketRange/:type?",
      component: _d19fc6b0,
      name: "market-marketRange-type"
    }, {
      path: "/news/page/:id?",
      component: _734ef354,
      name: "news-page-id"
    }, {
      path: "/live/:id",
      component: _0ef28367,
      name: "live-id"
    }, {
      path: "/market/:id",
      component: _6be268b7,
      name: "market-id"
    }, {
      path: "/member/:type",
      component: _a8816998,
      children: [{
        path: "",
        component: _3328ca92,
        name: "member-type"
      }, {
        path: "article-index",
        component: _c3011cc0,
        name: "member-type-article"
      }]
    }, {
      path: "/news/:id",
      component: _4a6af364,
      name: "news-id"
    }, {
      path: "/p/:id?",
      component: _080de57b,
      name: "p-id"
    }, {
      path: "/rss-detail/:id?",
      component: _b4841eb2,
      name: "rss-detail-id"
    }, {
      path: "/stock/:id?",
      component: _22159bbe,
      name: "stock-id"
    }, {
      path: "/subject/:id",
      component: _1ebc0837,
      name: "subject-id"
    }, {
      path: "/tags/:type?",
      component: _b522e01a,
      name: "tags-type"
    }, {
      path: "/user/:id?",
      component: _73b96f46,
      name: "user-id"
    }, {
      path: "/",
      component: _e542f99c,
      children: [{
        path: "",
        component: _70174796,
        name: "index"
      }, {
        path: "tag/:type?",
        component: _5741ee47,
        name: "index-tag-type"
      }]
    }, {
      path: "/:lang",
      component: _182c8070,
      children: [{
        path: "",
        component: _c55a1a1a,
        name: "lang-index"
      }, {
        path: "tag/:type?",
        component: _cc4a13f6,
        name: "lang-index-tag-type"
      }]
    }, {
      path: "/:lang/agreement",
      component: _a0ae4ab0,
      name: "lang-agreement"
    }, {
      path: "/:lang/audit",
      component: _53cc46f9,
      children: [{
        path: "",
        component: _72882288,
        name: "lang-audit"
      }, {
        path: "company",
        component: _4fe32f32,
        name: "lang-audit-company"
      }, {
        path: "failure",
        component: _71d80ef4,
        name: "lang-audit-failure"
      }, {
        path: "person",
        component: _0f4d595b,
        name: "lang-audit-person"
      }, {
        path: "review",
        component: _75d4fbde,
        name: "lang-audit-review"
      }, {
        path: "status",
        component: _14bc1110,
        name: "lang-audit-status"
      }, {
        path: "submitted",
        component: _47687965,
        name: "lang-audit-submitted"
      }, {
        path: "success",
        component: _aa798e26,
        name: "lang-audit-success"
      }]
    }, {
      path: "/:lang/column",
      component: _389c13aa,
      name: "lang-column"
    }, {
      path: "/:lang/contactUs",
      component: _55dfa57c,
      name: "lang-contactUs"
    }, {
      path: "/:lang/customerService",
      component: _7f5c5695,
      name: "lang-customerService"
    }, {
      path: "/:lang/glhProtocal",
      component: _5dc965c7,
      name: "lang-glhProtocal"
    }, {
      path: "/:lang/introduction",
      component: _2fdf5cec,
      name: "lang-introduction"
    }, {
      path: "/:lang/live",
      component: _c506527e,
      name: "lang-live"
    }, {
      path: "/:lang/market",
      component: _03484f91,
      name: "lang-market"
    }, {
      path: "/:lang/member",
      component: _74fc686f,
      name: "lang-member"
    }, {
      path: "/:lang/memberService",
      component: _c9b7304e,
      name: "lang-memberService"
    }, {
      path: "/:lang/myStock",
      component: _63f2e12a,
      name: "lang-myStock"
    }, {
      path: "/:lang/news",
      component: _59408830,
      name: "lang-news"
    }, {
      path: "/:lang/privacypolicy",
      component: _3ed27f50,
      name: "lang-privacypolicy"
    }, {
      path: "/:lang/recruit",
      component: _47254148,
      name: "lang-recruit"
    }, {
      path: "/:lang/relief",
      component: _42bb5063,
      name: "lang-relief"
    }, {
      path: "/:lang/search",
      component: _2fe049fd,
      name: "lang-search"
    }, {
      path: "/:lang/subject",
      component: _f050a566,
      name: "lang-subject"
    }, {
      path: "/:lang/column/columnist",
      component: _396b0be0,
      name: "lang-column-columnist"
    }, {
      path: "/:lang/live/index.1",
      component: _2db5dcc4,
      name: "lang-live-index.1"
    }, {
      path: "/:lang/member/failure",
      component: _dc3e3032,
      name: "lang-member-failure"
    }, {
      path: "/:lang/member/payment",
      component: _8ad76b3a,
      name: "lang-member-payment"
    }, {
      path: "/:lang/member/privilegeintro",
      component: _3eb0b30e,
      name: "lang-member-privilegeintro"
    }, {
      path: "/:lang/member/success",
      component: _6a67dc40,
      name: "lang-member-success"
    }, {
      path: "/:lang/my/comment",
      component: _5b13174e,
      name: "lang-my-comment"
    }, {
      path: "/:lang/my/favorite",
      component: _0c516986,
      name: "lang-my-favorite"
    }, {
      path: "/:lang/my/follower",
      component: _6abf90bf,
      name: "lang-my-follower"
    }, {
      path: "/:lang/my/following",
      component: _860ace80,
      name: "lang-my-following"
    }, {
      path: "/:lang/my/notification",
      component: _836bc2e8,
      name: "lang-my-notification"
    }, {
      path: "/:lang/my/publish",
      component: _8de22404,
      name: "lang-my-publish"
    }, {
      path: "/:lang/my/purchase",
      component: _6c984c22,
      name: "lang-my-purchase"
    }, {
      path: "/:lang/my/setting",
      component: _532e5282,
      name: "lang-my-setting"
    }, {
      path: "/:lang/my/stock",
      component: _448b1376,
      name: "lang-my-stock"
    }, {
      path: "/:lang/column/page/:id?",
      component: _0f566071,
      name: "lang-column-page-id"
    }, {
      path: "/:lang/column/user/:id?",
      component: _4cc9edad,
      name: "lang-column-user-id"
    }, {
      path: "/:lang/market/hotRange/:type?",
      component: _18cdaa8b,
      name: "lang-market-hotRange-type"
    }, {
      path: "/:lang/market/marketRange/:type?",
      component: _fd5e2aac,
      name: "lang-market-marketRange-type"
    }, {
      path: "/:lang/news/page/:id?",
      component: _832734d8,
      name: "lang-news-page-id"
    }, {
      path: "/:lang/live/:id",
      component: _2fb8d52e,
      name: "lang-live-id"
    }, {
      path: "/:lang/market/:id",
      component: _85d1fb8e,
      name: "lang-market-id"
    }, {
      path: "/:lang/member/:type",
      component: _fb98e794,
      children: [{
        path: "",
        component: _1690db8e,
        name: "lang-member-type"
      }, {
        path: "article-index",
        component: _f8b671bc,
        name: "lang-member-type-article"
      }]
    }, {
      path: "/:lang/news/:id",
      component: _9808cf60,
      name: "lang-news-id"
    }, {
      path: "/:lang/p/:id?",
      component: _da483a8e,
      name: "lang-p-id"
    }, {
      path: "/:lang/rss-detail/:id?",
      component: _9fb40dae,
      name: "lang-rss-detail-id"
    }, {
      path: "/:lang/stock/:id?",
      component: _3be6605f,
      name: "lang-stock-id"
    }, {
      path: "/:lang/subject/:id",
      component: _17cac216,
      name: "lang-subject-id"
    }, {
      path: "/:lang/tags/:type?",
      component: _12b9ad16,
      name: "lang-tags-type"
    }, {
      path: "/:lang/user/:id?",
      component: _4cea8148,
      name: "lang-user-id"
    }],

  fallback: false
}

export function createRouter() {
  return new Router(routerOptions)
}
